import React from 'react';
import { compose } from 'ramda';
import { RichText, Button, Image, Link } from '@synergycms_core/components/generic';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './Eurostarshotels.js';
import AvailSummarySendMail from '../AvailMainSideSummary/AvailSummarySendMail.jsx';
import { MULTIHOTEL_AVAIL_MODAL_LIMIT } from '../../../config/constants.js';

class TimeoutModalEurostars extends React.Component {
    static displayName = 'TimeoutModalEurostars';

    constructor(props) {
        super(props);
        
        const hotelLimitExceeded = 
            props.currentStep === "multiHotelAvail" && props.hotelsNumber > MULTIHOTEL_AVAIL_MODAL_LIMIT;

        this.state = {
            showSendMailForm: hotelLimitExceeded ? false : true,
            success: false
        };
    }

    toggleSendMailForm = e => {
        e && e.preventDefault();
        this.setState(state => ({
            showSendMailForm: !state.showSendMailForm,
            success: false
        }));
    };

    callbackSuccess = success => {
        this.setState(state => ({
            success: success
        }));
    };

    render() {
        const { classes } = this.props.theme.styles;
        const { idBtnsModal, hotelInfo, reload } = this.props

        const customerFormUser = ( this.props.reservation && this.props.reservation.getIn(['customer', 'email']) ) || this.props?.corporateInfo?.get?.('email');
        const social = hotelInfo?.get('socialNetworks');

        return (
            <div className={classes.timeoutModalTable}>
                <div className={classes.timeoutModalTableCell}>
                    <div className={classes.timeoutModalWhite}>
                        <Button
                            innerStyle={classes.closeButton}
                            onClick={reload}
                            icon={{ unicodeContent: 'e001' }}
                            id={[idBtnsModal.idCloseIcon]}
                        />
                        <Image svg={'stillThere'} innerStyle={classes.amenityIconTitle}/>
                        <RichText innerStyle={classes.timeoutModalTitle} text={'_%¿Sigues ahí?%_'} translate={true} />
                        <RichText
                            innerStyle={classes.timeoutModalInfo}
                            text={
                                '_%continúa con la reserva para disfrutar de nuestras ventajas exclusivas.%_'
                            }
                            translate={true}
                            ucFirst={true}
                        />
                        <ul className={classes.timeoutList}>
                            <li>
                                <RichText
                                innerStyle={classes.timeoutListInfo}
                                text={
                                    '_%mejor precio garantizado%_'
                                }
                                icon={{
                                    svg: 'stIcon10Percent',
                                    innerStyle: [classes.amenityIcon]
                                }}
                                translate={true}
                                ucFirst={true}
                                />
                            </li>
                            <li>
                                <RichText
                                innerStyle={classes.timeoutListInfo}
                                text={
                                    '_%beneficios exclusivos en cada reserva%_'
                                }
                                icon={{
                                    svg: 'diamond',
                                    innerStyle: [classes.amenityIcon]
                                }}
                                translate={true}
                                ucFirst={true}
                                />
                            </li>
                            <li>
                                <RichText
                                innerStyle={classes.timeoutListInfo}
                                text={
                                    '_%opción de cancelación flexible%_'
                                }
                                icon={{
                                    svg: 'flexibleCancellation',
                                    innerStyle: [classes.amenityIcon]
                                }}
                                translate={true}
                                ucFirst={true}
                                />
                            </li>
                        </ul>
                        <Button
                            innerStyle={classes.timeoutAcceptButton}
                            onClick={reload}
                            id={[idBtnsModal.idContinueBtn]}
                            richText={{
                                text: '_%continuar%_',
                                translate: true
                            }}
                        />
                        {this.state.showSendMailForm && (
                            <>
                            <RichText
                                innerStyle={classes.timeoutModalInfo}
                                text={
                                    '_%te enviaremos la selección para que puedas continuar más tarde.%_'
                                }
                                translate={true}
                                ucFirst={true}/>
                            <div className={classes.sendMailContainer}>
                                <AvailSummarySendMail
                                    callbackSuccess={this.callbackSuccess}
                                    callbackButtonForm={this.toggleSendMailForm}
                                    shortVersionSummary={true}
                                    placeholderUser={customerFormUser}
                                    reservationRequest={this.props.preReservation}
                                    currentStep={this.props.currentStep}
                                />
                            </div>
                            </>
                        )}
                        {this.state.success && (
                        <div>
                            <Image svg={'emailIconIdle'}/>
                            <RichText
                                ucFirst={true}
                                translate={true}
                                text={'_%se ha enviado tu solicitud%_'}
                                innerStyle={[classes.timeoutModalInfo, classes.centerText].join(' ')}
                            />
                        </div>
                        )}
                        {social && <ul className={classes.socialIconList}>
                            {social.map(function (network) {
                                return (
                                    <li className={classes.socialIconElement}>
                                        <Link
                                        key={network.get('code')}
                                        title={network.get('code')}
                                        image={{ svg: network.get('code') }}
                                        href={network.get('url') + '/' + network.get('user')}
                                        innerStyle={classes.socialLogo}
                                        />
                                    </li>
                                );
                            })}
                        </ul>}
                    </div>
                </div>
            </div>
        );
    }
};

export default compose(
    withThemeJSS({ styleFile, link: true  })
)(TimeoutModalEurostars);
